import React, { useEffect } from "react"
import { Paper, Typography, Grid, useMediaQuery } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import DefaultContainer from "template/DefaultContainer"
import { FormattedMessage, useIntl } from "react-intl"

const useStyle = makeStyles(theme => ({
  container: {
    height: "calc(100vh - 174px)",
    maxWidth: "940px",
  },
  ParentPaper: {
    backgroundColor: "#FFF",
    border: "solid",
    borderWidth: "1px",
    borderColor: "#e0e0e0",
    maxWidth: "940px",
    margin: "auto",
    paddingTop: "80px",
    paddingBottom: "80px",
    paddingLeft: "20px",
    paddingRight: "20px",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "20px",
      paddingBottom: "20px",
    },
  },
  SubFont: {
    color: "#9f9fa0",
    textAlign: "center",
    fontSize: "20px",
    lineHeight: 2,
    wordWrap: "break-word",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      lineHeight: 1.6,
    },
  },
}))

const SorryPage = () => {
  const classes = useStyle()
  const isPC = useMediaQuery("(min-width:960px)")
  const intl = useIntl()
  const documentTitle = intl.formatMessage({ id: "SorryPage.DocumentTitle" })

  useEffect(() => {
    document.title = documentTitle
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "AgreementCard-Pageview",
      pagePath: "/SorryPage",
      pageTitle: document.title,
    })
  }, [documentTitle])

  return (
    <DefaultContainer>
      <Grid
        container
        className={classes.container}
        justify="center"
        alignItems="center"
        direction="row"
      >
        <Grid item>
          <Paper elevation={0} className={classes.ParentPaper}>
            {isPC ? (
              <div>
                <Typography className={classes.SubFont}>
                  <FormattedMessage id="SorryPage.ContainerContentPc1" />
                </Typography>
                <Typography className={classes.SubFont}>
                  <FormattedMessage id="SorryPage.ContainerContentPc2" />
                </Typography>
                <Typography className={classes.SubFont}>
                  <FormattedMessage id="SorryPage.ContainerContentPc3" />
                </Typography>
              </div>
            ) : (
              <div>
                <Typography className={classes.SubFont}>
                  <FormattedMessage id="SorryPage.ContainerContent1" />
                  <br />
                  <FormattedMessage id="SorryPage.ContainerContent2" />
                </Typography>
                <Typography className={classes.SubFont}>
                  <FormattedMessage id="SorryPage.ContainerContent3" />
                  <br />
                  <FormattedMessage id="SorryPage.ContainerContent4" />
                </Typography>
              </div>
            )}
            <Typography className={classes.SubFont}>
              <FormattedMessage id="SorryPage.ContainerContentTextSorry1" />
            </Typography>
            <Typography className={classes.SubFont} id="textSorry">
              <FormattedMessage id="SorryPage.ContainerContentTextSorry2" />
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </DefaultContainer>
  )
}

export default SorryPage
